export const peerAnalyserColorTheme: any = {
    'IN_FORM': {
        bg: 'bg-status-in-form',
        text: 'text-status-text-in-form',
        svgColor: '#7ECA94',
        lockSvgColor: '#60AD77',
    },
    'ON_TRACK': {
        bg: 'bg-status-on-track',
        text: 'text-status-text-on-track',
        svgColor: '#90DCA6',
        lockSvgColor: '#5DC27A',
    },
    'OFF_TRACK': {
        bg: 'bg-status-off-track',
        text: 'text-status-text-off-track',
        svgColor: '#EEBD80',
        lockSvgColor: '#E7B16F',
    },
    'OUT_OF_FORM': {
        bg: 'bg-status-out-of-form',
        text: 'text-status-text-out-of-form',
        svgColor: '#F0AAA0',
        lockSvgColor: '#EC8C7E',
    },
    'PERFORMANCE_LOCKED': {
        bg: 'bg-[#F5F5F5]',
        text: 'text-black',
        svgColor: '#D1D6D6',
        lockSvgColor: '#D1D6D6',
    },
    'NOT_RATED': {
        bg: 'bg-[#F6F9F9]',
        text: 'text-black',
        svgColor: '#D1D6D6',
        lockSvgColor: '#D1D6D6',
    },
};
